import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  inject,
  PLATFORM_ID,
  ChangeDetectorRef,
  CUSTOM_ELEMENTS_SCHEMA,
} from "@angular/core";
import {
  FormArray,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";

import { CommonModule, DatePipe, isPlatformServer } from "@angular/common";

import {
  TuiAlertService,
  TuiButton,
  TuiIcon,
  TuiLabel,
  TuiLink,
  TuiTitle,
} from "@taiga-ui/core";
import {
  TuiProgressBar,
  TuiFieldErrorPipe,
  TuiCheckbox,
  TuiFilterByInputPipe,
  TuiFiles,
} from "@taiga-ui/kit";

import {
  TuiError,
  TuiDataList,
  TuiAppearance,
  TuiRoot,
  TuiTextfield,
  TuiDropdown, tuiDateFormatProvider
} from "@taiga-ui/core";
import {
  TuiDataListWrapper,
  TuiRadio,
  TuiAvatar,
  TuiBadge,
  TuiItemsWithMore,
  TuiProgress,
  TuiBadgedContent,
  TuiTabs,
  TuiInputNumber,
} from "@taiga-ui/kit";

import {
  TuiInputDateModule,
  TuiInputModule,
  TuiInputPhoneModule,
  TuiInputSliderModule,
  TuiInputTimeModule,
  TuiSelectModule,
  TuiTextfieldControllerModule,
  TuiTextareaModule,
  TuiInputTagModule,
  TuiComboBoxModule,
  TuiMultiSelectModule,
  TuiInputDateTimeModule,
  TuiInputNumberModule,
} from "@taiga-ui/legacy";
import { NgxSpinnerService } from 'ngx-spinner';
import { TUI_IS_E2E, TuiDay } from "@taiga-ui/cdk";
import { AsyncPipe } from "@angular/common";
import { of, timer, takeWhile, share, repeat, map, timeout, catchError, throwError } from "rxjs";
import { NG_EVENT_PLUGINS } from "@taiga-ui/event-plugins";
import { Router } from "@angular/router";
import { Meta, Title } from "@angular/platform-browser";
import { ClowderService } from "../../../services/clowder.service";
import { ProgramService } from "../../../services/program.service";
import { environment } from "../../../../environments/environment";
import { SignupuserService } from "../../../services/signupuser.service";
import { ClowderfrontUrl } from "../../../storan-constant";
import { AuthService } from "../../../services/auth.service";
@Component({
  selector: 'app-clean-photos',
  standalone: true,
  imports: [ReactiveFormsModule,
    CommonModule,
    AsyncPipe,
    TuiProgressBar,
    TuiButton,
    TuiDropdown,
    TuiLabel,
    TuiFieldErrorPipe,
    TuiError,
    TuiDataList,
    TuiAppearance,
    TuiRadio,
    TuiInputDateModule,
    TuiTextfield,
    TuiTextfieldControllerModule,
    TuiInputModule,
    TuiInputNumber,
    TuiInputPhoneModule,
    TuiInputTimeModule,
    TuiSelectModule,
    TuiTextareaModule,
    TuiCheckbox,
    TuiAvatar,
    TuiInputTagModule,
    TuiIcon,
    TuiProgress,
    TuiFilterByInputPipe,
    TuiFiles,
    TuiComboBoxModule,
    TuiMultiSelectModule,
    TuiBadgedContent,
    TuiDataListWrapper,
    TuiInputNumberModule,
    TuiInputSliderModule,
    TuiTextfieldControllerModule,
    TuiItemsWithMore,
    TuiTabs,
    FormsModule,
    TuiTitle,
    TuiInputDateTimeModule,
    TuiLink,
    TuiRoot],
  templateUrl: './clean-photos.component.html',
  styleUrl: './clean-photos.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [NG_EVENT_PLUGINS, DatePipe, tuiDateFormatProvider({ mode: 'MDY', separator: '/' })],
})
export class CleanRowPhotosComponent {
  currentSurveyStep: number = 4;
  currentStep: number = 4;
  current_upload_inner_step: number = 1;
  timeoutSec: any;
  spinnerPercentage: number = 0;
  spinnerContent: string = "Loading";
  private readonly alerts = inject(TuiAlertService);
  private uploadInProgress = false;
  isSubmitting: boolean = false;
  protected uploadProgress: any;
  showLoader: boolean = false;
  uploadComplete:boolean = false;
  uploadedFiles: {
    file: File; fileName: any; fileUrl: any; fileData: FormData; progress: number; isVideo: boolean; isTestimonial: boolean; isDeleted: boolean; isReadonly: boolean; trialAssetsDetails: any; isSkipAsset?: boolean; isPreloaded?: boolean;  // Add this new property
  }[] = [];
  fileControl = new FormControl();
  protected uploadForm = new FormGroup({
    file: new FormControl(null, Validators.required),
    applyStorenCornDate: new FormControl(null, Validators.required),
    dateOfPhoto: new FormControl(null, Validators.required),
    storenUseRate: new FormControl(null, Validators.required),
    storenState: new FormControl(null, Validators.required),
    storenNearestCity: new FormControl(null, Validators.required),
  });
  dataSetId: any;
  stateList: any[] = [];
  emailAddress: any;
  trailId: any;
  growerDetails: any;
  growerid: any;
  cleanRowPhotosStatus: any;
  decimalPattern = '^\\d*(\\.\\d{0,2}?$';
  endOfSeasonSurveyStatus: any;
  applicationLockSatus: any;
  satisfactionSurveyStatus: any;
  maxDate:any;
  allUploadsComplete:boolean = false;
  constructor(private router: Router, private authService: AuthService, private meta: Meta, private cdr: ChangeDetectorRef, private title: Title, private datepipe: DatePipe, private _clowderService: ClowderService, private signUpservice: SignupuserService, private programService: ProgramService, private spinner: NgxSpinnerService,) {
    this.title.setTitle("Upload Storen Clean Row Photos");
    this.meta.updateTag({ name: 'description', content: '' })
  }
  // ngAfterViewInit() {
  //   setTimeout(() => {
  //     document.querySelector('#cleanRows')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  //   },600);
  // }
  ngOnInit(): void {
    this.emailAddress = localStorage.getItem("email");
    let status = this.programService.getStatus();
    this.authService.checkAuthAndRedirect();
    this.cleanRowPhotosStatus = sessionStorage.getItem("cleanRowPhotosStatus") ? sessionStorage.getItem("cleanRowPhotosStatus") : "";
      if (this.cleanRowPhotosStatus === 'COMPLETED' || this.cleanRowPhotosStatus === 'LOCK' || this.cleanRowPhotosStatus === 'GETSTARTEDDISABLE' || !this.cleanRowPhotosStatus) {
   this.router.navigate(['/program']);
      }
    this.getStatesDropDown();
    this.getGrowerDetails();
    let dataSets = JSON.stringify(environment.ClowderConfig.datasets.find(item => Object.keys(item).includes('Corn-field')));
    this.dataSetId = JSON.parse(dataSets)['Corn-field'];
    this.maxDate = TuiDay.currentLocal();
  }
  getGrowerDetails() {
    this.programService.getgrowerdetailsbyEmailId(this.emailAddress).subscribe((res: any) => {
      this.growerDetails = JSON.parse(res);
      if (this.growerDetails.length > 0) {
        this.growerid = this.growerDetails[0].GROWER_ID;
        this.trailId = this.growerDetails[0].trail_id;
      }
    })
  }
  clearFormControl() {
    this.uploadForm.get("storenState")?.reset();
  }
  getStatesDropDown() {
    this.spinner.show();
    this.programService.getStatesDropDown().subscribe((response) => {
      if (response) {
        let data = JSON.parse(response);
        data.states.forEach((element: any) => {
          this.stateList.push(element.state);
        });
        this.stateList = this.stateList.sort();
        this.spinner.hide();
      } else {
        this.spinner.hide();
      }
    }, error => {
      this.spinner.hide();


    });
  }

  ischeckImageMandatoryFields(index: any) {
    let item = this.uploadedFiles[index];
    if (!item.trialAssetsDetails?.applyStorenCornDate || !item.trialAssetsDetails?.dateOfPhoto || !item.trialAssetsDetails.storenUseRate || !item.trialAssetsDetails.applyStorenCornDate
      || !item.trialAssetsDetails.storenUseRate || !item.trialAssetsDetails.storenNearestCity || !item.trialAssetsDetails.storenState) {
      return true;
    }
    return false;
  }

  isCheckAllFields() {
    let isValid = true;
    for (const item of this.uploadedFiles) {
      if (item.isDeleted) {
        continue;
      }
      if (!item.trialAssetsDetails?.applyStorenCornDate || !item.trialAssetsDetails?.dateOfPhoto || !item.trialAssetsDetails.storenUseRate 
        || !item.trialAssetsDetails.applyStorenCornDate
        || !item.trialAssetsDetails.storenUseRate || !item.trialAssetsDetails.storenNearestCity || !item.trialAssetsDetails.storenState) {
        isValid = false;
        return true;
      }
      // if (!item.isReadonly) {
      //   isValid = false;
      //   return;
      // }
    }
    return false;
    
    // return this.uploadedFiles.filter(item =>!item.isDeleted).every(item =>
    //   !item.trialAssetsDetails?.applyStorenCornDate  || !item.trialAssetsDetails?.dateOfPhoto
    //   || !item.trialAssetsDetails.storenUseRate 
    //     || !item.trialAssetsDetails.applyStorenCornDate
    //     || !item.trialAssetsDetails.storenUseRate || !item.trialAssetsDetails.storenNearestCity || !item.trialAssetsDetails.storenState);


  }
  
  async uploadImage() {
    try {
      this.spinner.show();
     
      const uploadPromises = this.uploadedFiles.map(async (asset) => {
        if (asset.isDeleted == false) {
          if (asset.isVideo) {
            this.timeoutSec = 300000; // 5 minutes for video only
          } else {
            this.timeoutSec = environment.timeoutSec;
          }
          return this.handleImageUpload(asset);
        }
        
        });

      await Promise.all(uploadPromises.filter(p => p));
      this.uploadProgress = Math.max(this.uploadProgress, 92);
      await new Promise(resolve => setTimeout(resolve, 400));
      this.uploadProgress = Math.max(this.uploadProgress, 95);
      await new Promise(resolve => setTimeout(resolve, 500));
      this.uploadProgress = 100;
      window.scrollTo(0, 0);
      // this.wasAssetSkipped = false;
      this.currentStep = 2;
      this.cdr.detectChanges();
    } catch (error) {
      this.handleError(error, 'Error during file upload process');
    } finally {
      this.spinner.hide();
      this.spinnerPercentage = 0;
      this.spinnerContent = "Loading";
    }
  }
  onFileUpload(event: any): void {
    this.allUploadsComplete = false;
    const files = event.target.files;
    for (let file of files) {
      const isVideo = file.type.includes("video");
      let fileName = file.name;
      const extension = fileName.split('.').pop();
      //const uniqueNumber = crypto.randomUUID();
      let uniqueNumber = Date.now();
      fileName = fileName.replace(`.${extension}`, `_${uniqueNumber}.${extension}`);
      const eventTarget = file;
      var reader = new FileReader();
      reader.readAsDataURL(eventTarget);
      reader.onload = async (e: any) => {
        let url = "";
        if (eventTarget?.type.indexOf('image') > -1) {
          url = e.target.result;
        }
        else if (eventTarget?.type.indexOf('video') > -1) {
          const videoFile = await this._clowderService.generateThumbnail(eventTarget);
          url = videoFile;
        }
        else if (file.name.indexOf('heic') > -1) {
          url = e.target.result
        }
        // Clear the file input
        this.fileControl.reset();
        const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }
        const fileData = new FormData();
        fileData.append('type', 'file');
        fileData.append('path', `/${fileName}`);
        fileData.append('file', eventTarget, fileName);
        //  const newFile = { file, progress: 0, isVideo };
        const newFile = {
          file,
          fileName: fileName,
          fileUrl: url,
          fileData,
          progress: 0,
          isVideo,
          isTestimonial: false,
          isDeleted: false,
          isReadonly: false,
          trialAssetsDetails: {},
          isPreloaded: false  // Set this for newly uploaded images
        };
        this.uploadedFiles.push(newFile);
        this.simulateUpload(newFile);
      }
    }
  }
 
  

  private handleError(error: any, customMessage: string = 'An error occurred'): void {
    console.error('API Error:', error);
    this.spinner.hide();
    this.alerts.open(customMessage, {
      label: 'Error!',
      appearance: 'error',
      autoClose: 5000
    }).subscribe();
  }
  simulateUpload(fileObj: { progress: number }): void {
    this.uploadComplete = false;
    const interval = setInterval(() => {
      fileObj.progress += 10;
      if (fileObj.progress >= 100) {
        fileObj.progress = 100;
        this.uploadComplete = true;
        clearInterval(interval);
        this.checkAllUploadsComplete();
      }
    }, 300);
  }

  checkAllUploadsComplete(): void {
    this.allUploadsComplete = this.uploadedFiles.every(file => file.progress === 100);
  }

  private async handleImageUpload(asset: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this._clowderService.uploadImage(asset.fileData, this.dataSetId)
        .pipe(
          timeout(this.timeoutSec),
          catchError(error => {
            this.handleError(error, `Error uploading ${asset.fileName}`);
            this.errorCaptureDB(error,`Error uploading ${asset.fileName}`);
            reject(error);
            return throwError(() => error);
          })
        )
        .subscribe({
          next: (res) => {
            if (res['id'] !== '') {
              resolve(this.uploadImageMetadata(res['id'], asset));

            }
          },
          error: (error) => reject(error)
        });
    });
  }
  convertToDate(tuiDay: TuiDay): string {
    if (tuiDay === null || tuiDay === undefined) {
      return '';
    }
    const date = new Date(tuiDay.year, tuiDay.month, tuiDay.day);
    return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
  }
  async uploadImageMetadata(fileId: any, asset: any) {
    this.spinner.show();
    const SubmittedOn = this.datepipe.transform(new Date(), 'MM/dd/yyyy HH:mm:ss');
    const appliedStoranDate = asset.trialAssetsDetails?.applyStorenCornDate
      ? this.convertToDate(asset.trialAssetsDetails?.applyStorenCornDate)
      : new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    const dateoFphoto = asset.trialAssetsDetails?.dateOfPhoto ? this.convertToDate(asset.trialAssetsDetails?.dateOfPhoto)
      : new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    const imagePath = ClowderfrontUrl + 'Corn-field/' + asset.fileName;
    let saveAssetCleanPhoto = {
      "MS-Trial Type": "SSP",
      "MS-Trial ID": this.trailId,
      "MS-Asset Type": asset.isVideo ? "Video" : "Photo",
      "MS-Asset-url": imagePath,
      "MS-SubmittedOn": SubmittedOn,
      "MS-Asset File Name": asset.fileName,
      "MS-CU Role": this.growerDetails[0]['CU_Description'],
      "MS-Crop": "Corn (field)",
      "MS-Product Type": "Herbicide",
      "MS-Product": "Storen",
      "MS-Submitter Email": this.emailAddress,
      "MS-Program Status": "Clean Row Photos",
      "MS-SU Approval Status": "Pending",
      "MS-SU Approved or Rejected Date": "",
      "MS-SU Approved or Rejected by": "",
      "MS-SU Comments": "",
      "MS-Legal Approval Status": "Pending",
      "MS-Legal Approved or Rejected Date": "",
      "MS-Legal Comments": "",
      "MS-Legal Approved or Rejected by": "",
      "MS-Legal Rejected Asset File Status": "",
      "MS-SU Rejected Asset File Status": "",
      "MS-Clean Row Photos": [
        {
          "MS-Applied storen date": appliedStoranDate,
          "MS-Date of Photo": dateoFphoto,
          "MS-Use Rate": asset.trialAssetsDetails?.storenUseRate + ' qt/A',
          "MS-Nearest City": asset.trialAssetsDetails?.storenNearestCity,
          "MS-State": asset.trialAssetsDetails?.storenState,
          "MS-Delete": asset.isDeleted,
        }
      ],
    }
    return this._clowderService.uploadImageMetadata(fileId, saveAssetCleanPhoto, this.emailAddress)
      .pipe(
        catchError(error => {
          this.handleError(error, `Error uploading metadata for ${asset.fileName}`);
          this.errorCaptureDB(error,`Error uploading metadata for ${asset.fileName}}`);
          this.spinnerPercentage = 0;
          this.spinnerContent = "Loading";
          this.spinner.hide();
          return throwError(() => error);
        })
      )
      .subscribe({
        next: (res) => {
          if(res){
            this.updateStatusDB();
            sessionStorage.setItem("cleanRowPhotosStatus", "COMPLETED");
            this.applicationLockSatus = sessionStorage.getItem("applicationLockSatus");
            this.satisfactionSurveyStatus = sessionStorage.getItem("satisfactionSurveyStatus");
            this.cleanRowPhotosStatus = sessionStorage.getItem("cleanRowPhotosStatus");
            this.endOfSeasonSurveyStatus = sessionStorage.getItem("endOfSeasonSurveyStatus");
            if(this.endOfSeasonSurveyStatus == 'COMPLETED' && this.cleanRowPhotosStatus == 'COMPLETED' && this.satisfactionSurveyStatus == 'COMPLETED' && this.applicationLockSatus == 'COMPLETED'){
              this.router.navigate(['/program-complete']).then(()=>{
                window.scrollTo({top:0,behavior:'smooth'});
              });
              // this.currentStep = 6;
            }else{
              this.current_upload_inner_step = 3;
            }
            setTimeout(() => {
              this.spinner.hide();
              document.querySelector('#cleanRowThanks')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            },600)
            this.cdr.detectChanges();
            this.spinner.hide();
          }
          // if (!res) {
          //   this.spinnerPercentage = 0;
          //   this.spinnerContent = "Loading";
          //   this.spinner.hide();
          // }
        },
        error: (error) => {
          this.spinnerPercentage = 0;
          this.spinnerContent = "Loading";
          this.spinner.hide();
          this.handleError(error, `Error uploading metadata for ${asset.fileName}`);
          this.errorCaptureDB(error,`Error uploading metadata for ${asset.fileName}}`);
        }
      });
  }

  errorCaptureDB(error:any,errorMsgs:any){
    let newVar = this.stripHtmlTags(error.error);
    let textLog = 'GrowerId:'+this.growerid+','+'Email:'+this.emailAddress+','+"Program:Clean-row-photos,Message="+error.message+"Error:"+newVar;  
    this.programService.errorDetailsLog(textLog, errorMsgs).subscribe(res => {
    }, (error) => {
      console.error('Error saving dataloop API :', error);
    });

  }
  private stripHtmlTags(html: string): string {
    if (typeof html !== 'string') return '';
    return html.replace(/<[^>]*>/g, '').replace(/\n/g, ' ').trim();
  }
  removeFile(index: number): void {
    this.uploadedFiles.splice(index, 1);
  }

  continueToDetails() {
    this.current_upload_inner_step = 2;
  }
  hasNoUploadedFiles(): boolean {
    // No files at all
    if (this.uploadedFiles.length === 0) {
      return true;
    }
    return false;
  }
  selectImageVideos() { }
  confirmImageDetails(index: any) {
    let item = this.uploadedFiles[index]
    if (!item.trialAssetsDetails?.applyStorenCornDate || !item.trialAssetsDetails?.dateOfPhoto || !item.trialAssetsDetails.storenUseRate || !item.trialAssetsDetails.applyStorenCornDate
      || !item.trialAssetsDetails.storenUseRate || !item.trialAssetsDetails.storenNearestCity || !item.trialAssetsDetails.storenState) {
      this.alerts.open(`<strong>Please enter all mandatory fields for trial assets. Asset Name: ${item.fileName}</strong>`,
        { label: 'Error!', appearance: 'negative', autoClose: 5000 }).subscribe();
      return; // Exit early on validation failure
    }
    this.uploadedFiles[index].isReadonly = true;
    this.uploadedFiles[index].isDeleted = false;
  }
  deleteImage(index: any) {
    this.uploadedFiles[index].isReadonly = true;
    this.uploadedFiles[index].isDeleted = true;
  }
  editDetails(index: any) {
    this.uploadedFiles[index].isReadonly = false;
    this.uploadedFiles[index].isDeleted = false;
  }
  submitDetails() { }
  addMoreAssets() {
    this.currentSurveyStep = 4;
  }

  validateNumberInput(event: any, index: number) {
    const value = event.target.value;
    if (!/^\d*$/.test(value)) {
      this.uploadedFiles[index].trialAssetsDetails.storenUseRate = value.replace(/\D/g, '');
    }
  }
  restrictToNumbersAndDecimal(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const key = event.key;

    const cursorPosition = input?.selectionStart ?? 0;

    // Always allow control keys
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
    if (allowedKeys.includes(key)) {
      return;
    }
    event.preventDefault();
    if (key >= '0' && key <= '9') {
      let newValue = '';
      let newPosition = cursorPosition + 1;
      // If cursor is before decimal point or no decimal exists
      if (!value.includes('.') || cursorPosition <= value.indexOf('.')) {
        const beforeDecimal = value.split('.')[0];
        // Don't allow more than 2 digits before decimal
        if (beforeDecimal.length >= 2) {
          return;
        }
        // Insert number at cursor position
        newValue = value.slice(0, cursorPosition) + key + value.slice(cursorPosition);
        // Add decimal point automatically after 2 digits
        if (newValue.length === 2 && !newValue.includes('.')) {
          newValue += '.';
          // Move cursor after the decimal point
          newPosition = 3;
        }
      } else {
        // If cursor is after decimal point
        const parts = value.split('.');
        // Don't allow more than 2 digits after decimal
        if (parts[1] && parts[1].length >= 2) {
          return;
        }
        newValue = value.slice(0, cursorPosition) + key + value.slice(cursorPosition);
      }
      input.value = newValue;
      this.uploadedFiles[index].trialAssetsDetails.storenUseRate = newValue;
      //Set cursor position
      setTimeout(() => {
        input.setSelectionRange(newPosition, newPosition);
      }, 0);
    } else if (key === '.' && !value.includes('.') && value.length > 0 && value.length <= 2) {
      // Allow decimal point only if not already present and there are 1-2 digits before it
      let newValue = value + '.';
      input.value = newValue;
      this.uploadedFiles[index].trialAssetsDetails.storenUseRate = newValue;
      // Move cursor after the decimal point
      const newPosition = newValue.length;
      setTimeout(() => {
        input.setSelectionRange(newPosition, newPosition);
      }, 0);
    }
  }
  allowDecimalInput(event: KeyboardEvent, index: any) {
    const currentValue = this.uploadedFiles[index].trialAssetsDetails.storenUseRate;
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab', '.', '-', 'Home', 'End'];
    const isNumber = /^[0-9]$/.test(event.key);
    const isAllowed = allowedKeys.includes(event.key);
    if (!isNumber && !isAllowed) {
      event.preventDefault();
    }
    //prevent multiple decimals
    if (event.key === '.' && currentValue?.includes('.')) {
      event.preventDefault();
    }

    //Prevent more than 2 decimal places
    const parts = currentValue?.split('.');
    if (parts?.length === 2 && parts[1].length >= 2 && event.key !== 'Backspace') {
      event.preventDefault();
    }
  }
  formattoTwoDecimals(index: any) {
    const currentValue = this.uploadedFiles[index].trialAssetsDetails.storenUseRate;
    const num = parseFloat(currentValue);
    if (!isNaN(num)) {
      this.uploadedFiles[index].trialAssetsDetails.storenUseRate = num.toFixed(2);
    }
  }
  onRateInputBlur(event: any, index: number) {
    const value = event.target.value;
    if (!value) return;
    // Format to ensure proper decimal places
    let formattedValue = value;
    // Ensure two digits before decimal
    let parts = formattedValue.split('.');
    let beforeDecimal = parts[0] || '';
    // Pad with leading zero if single digit
    if (beforeDecimal.length === 1) {
      beforeDecimal = '0' + beforeDecimal;
    } else if (beforeDecimal.length > 2) {
      // Truncate to 2 digits if somehow more got through
      beforeDecimal = beforeDecimal.slice(0, 2);
    }
    // Ensure exactly 2 decimal places
    let afterDecimal = (parts[1] || '00').padEnd(2, '0').slice(0, 2);
    formattedValue = beforeDecimal + '.' + afterDecimal;
    event.target.value = formattedValue;
  }
  // confirmAndSubmitAssets() {
  //   this.current_upload_inner_step = 3;
  // }
  async confirmAndSubmitAssets() {
    this.spinner.show();
    let isValid = true;
    try {
      // Validate uploaded files
      for (const item of this.uploadedFiles) {
        if (item.isDeleted) {
          continue;
        }

        if (!item.trialAssetsDetails?.applyStorenCornDate || !item.trialAssetsDetails?.dateOfPhoto || !item.trialAssetsDetails.storenUseRate || !item.trialAssetsDetails.applyStorenCornDate
          || !item.trialAssetsDetails.storenUseRate || !item.trialAssetsDetails.storenNearestCity || !item.trialAssetsDetails.storenState) {
          isValid = false;
          this.alerts.open(`<strong>Please enter all mandatory fields for trial assets. Asset Name: ${item.fileName}</strong>`,
            { label: 'Error!', appearance: 'negative', autoClose: 5000 }).subscribe();
          return; // Exit early on validation failure
        }


        if (!item.isReadonly) {
          isValid = false;
          this.alerts.open(`<strong>Please confirm the image details provided for Asset: ${item.fileName}</strong>`,
            { label: 'Confirmation', appearance: 'info', autoClose: 5000 }).subscribe();
          return; // Exit early on validation failure
        }
      }

      if (isValid) {
        this.isSubmitting = true;
        this.showLoader = true;
        this.uploadInProgress = true;
        this.uploadProgress = 0;
        this.spinnerContent = "Uploading Metadata";
        this.spinnerPercentage = 50;
        try {
          await this.uploadImage();
          // let saveApplCheckInObj = {
          //   "GrowerId": this.growerid,
          //   "TrailId": this.trailId,
          //   "ProgramScheduleId": 3,
          //   "Programstatus": "Completed"
          // }
          // this.programService.insertprogramdetails(saveApplCheckInObj).subscribe(async () => {
          //   await this.uploadImage();
          //   // this.current_upload_inner_step = 3;
          //   // this.cdr.detectChanges();
          //   // this.spinner.hide();
          // }, (error) => {
          //   this.spinner.hide();
          //   console.error('Error saving API :', error);
          // });
        } catch (error) {
          throw error;
        }
      }
    } catch (error) {
      this.alerts.open('Error uploading files. Please try again.', {
        label: 'Error!',
        appearance: 'error',
        autoClose: 5000
      }).subscribe();
    } finally {
      this.isSubmitting = false;
      this.showLoader = false;
      this.uploadInProgress = false;
      this.spinner.hide();
      this.spinnerPercentage = 0;
      this.spinnerContent = "Loading";
    }
  }

  updateStatusDB(){
    let saveApplCheckInObj = {
      "GrowerId": this.growerid,
      "TrailId": this.trailId,
      "ProgramScheduleId": 3,
      "Programstatus": "Completed"
    }
    this.programService.insertprogramdetails(saveApplCheckInObj).subscribe(async () => {
      
      // this.current_upload_inner_step = 3;
      // this.cdr.detectChanges();
      // this.spinner.hide();
    }, (error) => {
      this.spinner.hide();
      console.error('Error saving API :', error);
    });
  }
  goToEndOfSeasonSurvey() {
    this.currentStep = 5;
    this.currentSurveyStep = 5;
    // this.router.navigate(['/end-of-season-survey'])
    this.router.navigate(['/program']).then(()=>{
      window.scrollTo({top:0,behavior:'smooth'});
    })
  }
  protected readonly value$ =
    inject(TUI_IS_E2E) || isPlatformServer(inject(PLATFORM_ID))
      ? of(30)
      : timer(300, 200).pipe(
        takeWhile((value) => value <= 100),
        share(),
        repeat()
      );
  protected readonly color$ = this.value$.pipe(
    map((value) => {
      return "var(--acp-aab400)";
    })
  );
}





















